import React from 'react';
import { Text, Skeleton } from '../../../../components';
import { FormIntroduction } from './FormIntroduction';
import './LoadingState.scss';

export const LoadingState = () => {
    return (
        <div className="loading-state">
            <FormIntroduction />
            <div className="loading-state__message">
                <Text className="loading-state__text">Retrieving migration appliance settings...</Text>
            </div>
            <Skeleton active paragraph={{ rows: 8 }} />
        </div>
    );
};

